<template>
  <div id="ly_scenic_ticket">
    <div class="page-header">
      <el-page-header @back="$router.back()" :content="`票种管理 - ${scenicName}`" />
      <el-button type="primary" size="small" @click="openDialog()">添加票种</el-button>
    </div>

    <el-table :data="ticketList" v-loading="tableLoading" border style="width:100%">
      <el-table-column label="排序" prop="sortNo" width="70" align="center" />
      <el-table-column label="票种名称" prop="name" min-width="150" />
      <el-table-column label="票种类型" prop="ticketType" width="100" align="center">
        <template slot-scope="{row}">
          <el-tag size="mini" :type="ticketTypeMap[row.ticketType] && ticketTypeMap[row.ticketType].tag">
            {{ ticketTypeMap[row.ticketType] ? ticketTypeMap[row.ticketType].label : '-' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="票价" prop="price" width="100" align="right">
        <template slot-scope="{row}">
          <span class="util-money">¥{{ row.price }}</span>
          <div v-if="row.originalPrice" class="original-price">原价¥{{ row.originalPrice }}</div>
        </template>
      </el-table-column>
      <el-table-column label="包含人数" prop="includeCount" width="90" align="center">
        <template slot-scope="{row}">{{ row.includeCount || 1 }}人</template>
      </el-table-column>
      <el-table-column label="说明" prop="description" min-width="180" show-overflow-tooltip />
      <el-table-column label="状态" prop="status" width="80" align="center">
        <template slot-scope="{row}">
          <el-tag size="mini" :type="row.status === 1 ? 'success' : 'info'">
            {{ row.status === 1 ? '可售' : '停售' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="{row}">
          <el-button type="text" @click="openDialog(row)">编辑</el-button>
          <el-button type="text" style="color:#F56C6C" @click="deleteTicket(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加/编辑票种弹窗 -->
    <el-dialog :title="ticketForm.id ? '编辑票种' : '添加票种'" :visible.sync="dialogVisible" width="620px">
      <el-form :model="ticketForm" :rules="ticketRules" ref="ticketFormRef" label-width="100px">
        <el-form-item label="票种名称" prop="name">
          <el-input v-model="ticketForm.name" placeholder="如：成人票、家庭套票" maxlength="50" show-word-limit />
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="票种类型" prop="ticketType">
              <el-select v-model="ticketForm.ticketType" placeholder="请选择" style="width:100%">
                <el-option v-for="(v, k) in ticketTypeMap" :key="k" :label="v.label" :value="Number(k)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="包含人数">
              <el-input-number v-model="ticketForm.includeCount" :min="1" :max="100" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="票价（元）" prop="price">
              <el-input-number v-model="ticketForm.price" :min="0" :precision="2" :step="10" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原价（元）">
              <el-input-number v-model="ticketForm.originalPrice" :min="0" :precision="2" :step="10" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="ticketForm.status">
                <el-radio :label="1">可售</el-radio>
                <el-radio :label="2">停售</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序号">
              <el-input-number v-model="ticketForm.sortNo" :min="0" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="票种说明">
              <el-input v-model="ticketForm.description" type="textarea" :rows="3" placeholder="票种简要说明" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="使用须知">
              <el-input v-model="ticketForm.useNotice" type="textarea" :rows="3" placeholder="使用须知、退改政策等" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="saveTicket">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ly_scenic_ticket",
  data() {
    return {
      scenicId: null,
      scenicName: "",
      tableLoading: false,
      ticketList: [],
      dialogVisible: false,
      saveLoading: false,
      ticketTypeMap: {
        1: { label: "成人票", tag: "" },
        2: { label: "儿童票", tag: "success" },
        3: { label: "老年票", tag: "warning" },
        4: { label: "学生票", tag: "info" },
        5: { label: "家庭套票", tag: "danger" },
        6: { label: "团体票", tag: "" },
      },
      ticketForm: this.initTicketForm(),
      ticketRules: {
        name: [{ required: true, message: "请输入票种名称", trigger: "blur" }],
        ticketType: [{ required: true, message: "请选择票种类型", trigger: "change" }],
        price: [{ required: true, message: "请输入票价", trigger: "blur" }],
      },
    };
  },
  created() {
    this.scenicId = this.$route.query.scenicId;
    this.scenicName = this.$route.query.scenicName || "景区";
    this.loadTickets();
  },
  methods: {
    initTicketForm() {
      return { id: null, scenicId: null, name: "", ticketType: null, price: 0, originalPrice: null, includeCount: 1, description: "", useNotice: "", status: 1, sortNo: 0 };
    },
    async loadTickets() {
      this.tableLoading = true;
      try {
        let { code, data } = await this.$axios.get(`/api/v1/manage/travelScenic/ticket/${this.scenicId}`);
        if (code === 1) this.ticketList = data.list || [];
      } finally {
        this.tableLoading = false;
      }
    },
    openDialog(row) {
      this.ticketForm = row ? { ...row } : this.initTicketForm();
      this.ticketForm.scenicId = Number(this.scenicId);
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.ticketFormRef && this.$refs.ticketFormRef.clearValidate());
    },
    saveTicket() {
      this.$refs.ticketFormRef.validate(async (valid) => {
        if (!valid) return;
        this.saveLoading = true;
        try {
          let url = "/api/v1/manage/travelScenic/ticket";
          let { code } = this.ticketForm.id
            ? await this.$axios.put(url, this.ticketForm)
            : await this.$axios.post(url, this.ticketForm);
          if (code === 1) {
            this.$message.success(this.ticketForm.id ? "修改成功" : "添加成功");
            this.dialogVisible = false;
            this.loadTickets();
          }
        } finally {
          this.saveLoading = false;
        }
      });
    },
    deleteTicket(row) {
      this.$confirm(`确认删除票种「${row.name}」？`, "删除票种", {
        confirmButtonText: "确认删除", cancelButtonText: "取消", type: "warning"
      }).then(async () => {
        let { code } = await this.$axios.delete("/api/v1/manage/travelScenic/ticket", { id: row.id });
        if (code === 1) { this.$message.success("删除成功"); this.loadTickets(); }
      }).catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
#ly_scenic_ticket {
  padding: 16px;
  .page-header {
    display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;
  }
  .util-money { font-weight: 600; color: #F56C6C; }
  .original-price { font-size: 11px; color: #999; text-decoration: line-through; }
}
</style>
